import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { addCourse, getCourse, setActiveCourse, updateCourse } from "actions/courses";
import { setPageActions, setPageTitle } from "actions/header";
import { addError } from "actions/index";
import { getSection, getSectionByGraphId } from "actions/sections";
import { ASSESSMENT_MATRIX } from "constants/matrixTypes";
import CustomCoreContent from "containers/CoreContent/Custom";
/*import MatrixForm from 'containers/Matrix/MatrixForm/MatrixForm';**/

import MatrixForm from "containers/Matrix/Form/MatrixForm";
import CourseForm from 'containers/Forms/CourseForm';
import api from "lib/api";
import React, { Component } from "react";
import { translate } from '@haldor/ui';
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import { Expandable } from "UI";
import { Editor } from "UI/Inputs";
import * as microsoftTeams from "@microsoft/teams-js";

var CreateCourses = /*#__PURE__*/function (_Component) {
  _inherits(CreateCourses, _Component);

  var _super = _createSuper(CreateCourses);

  function CreateCourses(props) {
    var _this;

    _classCallCheck(this, CreateCourses);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "quillValidation", function (value) {
      if (typeof value !== "undefined" && value !== "") {
        // Field passes validation, return a undefined error for this field
        // Rule: Not undefined and not an empty string and not over 200 characters
        return undefined;
      } // Field failed validation, return error for this field (String)


      return _this.props.translate("field-needs-input");
    });

    _defineProperty(_assertThisInitialized(_this), "required", function (value) {
      if (typeof value !== "undefined" && value !== "") {
        if (value.length > 199) {
          // Field failed validation, return error for this field (String)
          return _this.props.translate("field-max-200-chars");
        } // Field passes validation, return a undefined error for this field
        // Rule: Not undefined and not an empty string and not over 200 characters


        return undefined;
      } // Field failed validation, return error for this field (String)


      return _this.props.translate("field-needs-input");
    });

    _defineProperty(_assertThisInitialized(_this), "submit", function (values) {
      return new Promise(function (resolve) {
        var coreContent = _this.state.coreContent;
        var _this$props = _this.props,
            currentUser = _this$props.currentUser,
            initialValues = _this$props.initialValues;
        values.typeOfSchooling = currentUser.schools.getActiveSchool(currentUser.userId).type;
        values.subjectCode = values.courseCode;

        if (_this.state.groupId != null) {
          values.accessibleBy = [{
            ReferenceType: "SECTION",
            ReferenceId: _this.state.groupId
          }];
        }

        var detail = {};
        detail.id = values.details[0].id;
        detail.purpose = values.details[0].purpose;
        detail.matrix = _this.state.matrix;
        detail.coreContent = coreContent;

        if (detail.matrix != null && detail.matrix._ParagraphSet != null) {
          detail.matrix._ParagraphSet.forEach(function (paragraph) {
            paragraph.rows.forEach(function (row) {
              if (_this.props.editView == false) {
                row.id = 0;
              }

              row.cells = row.cells.filter(function (step) {
                return step.gradeF == null;
              });
              row.cells.forEach(function (cell) {
                if (_this.props.editView == false) {
                  cell.id = null;
                }
              });
            });
          });

          var matrix = {
            Title: detail.matrix.Title,
            DisableNotAchieved: detail.matrix.disableNotAchieved,
            Type: detail.matrix.Type,
            ParagraphSet: JSON.stringify(detail.matrix._ParagraphSet)
          };
          detail.matrixId = values.details[0].matrixID;

          if (values.details[0] != null && values.details[0].matrixID != 0 && values.details[0].matrixID != null) {
            matrix.id = values.details[0].matrixID;
          } else {
            matrix.id = 0;
          }

          detail.matrix = matrix;
        }

        values.details = [detail];

        var that = _assertThisInitialized(_this);

        if (_this.props.editView == false || initialValues == null) {
          _this.props.addCourse(values, function (data) {
            var section = _this.props.group;
            section.courses.push({
              id: data
            });
            api.put("sections", section).then(function () {
              microsoftTeams.app.getContext().then(function (context) {
                _this.props.getSectionByGraphId(context.team.groupId);
              });

              if (values.status == "COURSE_PUBLISHED") {
                if (_this.props.onClose != null) {
                  _this.props.onClose();
                } else {
                  window.history.go(-1);
                }
              } else {
                _this.props.addError(_this.props.translate("changes-saved"), "info");

                _this.setState({
                  loading: true
                });

                _this.props.getCourse(data).then(function () {
                  _this.props.setPageTitle(_this.props.translate("update-course"));

                  _this.setState({
                    loading: false
                  });
                });
              }

              resolve(data);
            });
          });
        } else {
          values.id = initialValues.id;

          _this.props.updateCourse(values, function (data) {
            resolve(data);

            _this.props.addError(_this.props.translate("changes-saved"), "info");
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onCoreContentChange", function (content) {
      _this.setState({
        coreContent: content
      });
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      var _this$props$match;

      microsoftTeams.app.getContext().then(function (context) {
        var foundGroup = _this.props.groups.find(function (group) {
          return group.graphId == context.team.groupId;
        });

        if (foundGroup != null) {
          _this.setState({
            groupId: foundGroup.id
          });

          if (_this.props.group == null) {
            _this.props.getSection(foundGroup.id);
          }
        }
      });
      var courseId = ((_this$props$match = _this.props.match) === null || _this$props$match === void 0 ? void 0 : _this$props$match.params.courseId) || _this.props.courseId;

      if (courseId != null) {
        _this.props.setPageTitle(_this.props.translate("update-course"));

        _this.setState({
          loading: true
        });

        _this.props.getCourse(_this.props.courseId).then(function () {
          if (_this.props.initialValues != null) {
            if (_this.props.initialValues.details[0].matrix != null) {
              var matrix = JSON.parse(JSON.stringify(_this.props.initialValues.details[0].matrix));

              _this.setState({
                matrix: matrix
              });
            }

            var coreContent = null;

            if (_this.props.initialValues.details != null) {
              if (_this.props.initialValues.details.length > 0) {
                coreContent = _this.props.initialValues.details[0].coreContent;

                _this.setState({
                  coreContent: coreContent
                });
              }
            }
          }

          _this.setState({
            loading: false
          });
        });
      } else {
        _this.props.setPageTitle(_this.props.translate("create-course"));

        _this.setState({
          loading: false
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      _this.props.setActiveCourse();
    });

    _defineProperty(_assertThisInitialized(_this), "onCourseCreateFormClose", function (reload, skipPrompt) {
      if (_this.props.onClose != null) {
        _this.props.onClose();
      } else {
        // Reload tab
        _this.props.history.push('/haldor-tab');
      }
    });

    _this.state = {
      matrix: null,
      coreContent: null,
      groupId: null,
      loading: false
    };

    _this.onMatrixFormUpdate.bind(_assertThisInitialized(_this));

    return _this;
  }

  _createClass(CreateCourses, [{
    key: "onMatrixFormUpdate",
    value: function onMatrixFormUpdate(form) {
      var matrix = Object.assign({}, form);
      this.setState({
        matrix: matrix
      });
    }
  }, {
    key: "render",
    value: function render() {
      var initialValues = this.props.initialValues;

      if (this.state.loading) {
        return /*#__PURE__*/React.createElement("div", null);
      }

      return /*#__PURE__*/React.createElement(CourseForm, {
        onClose: this.onCourseCreateFormClose,
        editView: initialValues != null,
        group: this.props.group
      });
    }
  }]);

  return CreateCourses;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    initialValues: state.Courses.course,
    currentUser: state.user.currentUser,
    groups: state.sections.educationGroups,
    group: state.sections.activeSection
  };
}

export default connect(mapStateToProps, {
  addCourse: addCourse,
  updateCourse: updateCourse,
  setPageTitle: setPageTitle,
  setPageActions: setPageActions,
  setActiveCourse: setActiveCourse,
  getCourse: getCourse,
  addError: addError,
  getSectionByGraphId: getSectionByGraphId,
  getSection: getSection
})(reduxForm({
  form: "CreateCoursesForm",
  destroyOnUnmount: true
})(CreateCourses));